import Agent from "./agent.jsx";

export const comfirmBooking = async (appointmentData, shopId) => {
  // Your API call to authenticate the user
  // If successful, save the token to localStorage
  const { requests } = Agent();
  const token = localStorage.getItem("authToken");
  const params = {
    // replace with actual GUID
    StaffId: appointmentData.staffId, // replace with actual GUID
    ServiceList: appointmentData.services,
    Date: appointmentData.date, // ISO format is best for C#
    Time: appointmentData.time, // TimeSpan as HH:mm:ss
    AdditionalMinutes: 0,
  };
  return await requests.post(
    `/Appointment/CreateCustomerAppointment`,
    params,
    token,
    shopId
  );
};

export const getAppointment = async (id, shopId) => {
  // Your API call to authenticate the user
  // If successful, save the token to localStorage
  const { requests } = Agent();
  const token = localStorage.getItem("authToken");
  return await requests.get(`/Appointment/${id}`, token, shopId);
};
export const getAppointments = async (shopId) => {
  // Your API call to authenticate the user
  // If successful, save the token to localStorage
  const { requests } = Agent();
  const token = localStorage.getItem("authToken");
  return await requests.get(
    `/Appointment/customer-appointments`,
    token,
    shopId
  );
};
export const deleteAppointment = async (appointmentId, shopId) => {
  // Your API call to authenticate the user
  // If successful, save the token to localStorage
  const { requests } = Agent();
  const token = localStorage.getItem("authToken");

  return await requests.put(
    `/Appointment/Cancel-appointment?id=${appointmentId}&shopId=${shopId}`,
    null,
    token,
    shopId
  );
};
